<template>
  <div style="height: 100%;overflow-y: auto;padding:10px">
    <!-- 年检登记 -->
    <enrollment :title="$t('maintenance.NJ')" :size="size" @handleQuery="handleQuery" @add="add"></enrollment>
    <!-- 车辆列表 -->
    <div class="page_container_a">
      <el-table :data="dataList" border :size="size" highlight-current-row v-loading="loading">
        <el-table-column :label="$t('maintenance.order')" align="center" type="index" min-width="90"></el-table-column>
        <el-table-column :label="$t('vehicle.carNo')" align="center" prop="carNo"></el-table-column>
        <el-table-column :label="$t('maintenance.beginCheckTime')" align="center" prop="beginCheckTime">
          <template slot-scope="scope">
            {{scope.row.beginCheckTime }} {{$t('time.to')}} {{ scope.row.nextCheckTime}}
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('time.to')" align="center" prop="nextCheckTime"></el-table-column> -->
        <el-table-column :label="$t('maintenance.OPTName')" align="center" prop="OPTName"></el-table-column>
        <el-table-column  :label="$t('public.Operation')" align="center" min-width="150" fixed="right">
          <template slot-scope="scope">
            <el-link
              :underline="false" 
              style="margin-right:20px" 
              @click="edit(scope.row)">
              <i class="iconfont icon-icon_operat_edite" style="height: 16px;width:16px"></i> {{$t("public.edit")}}
            </el-link>
            <el-link
              :underline="false" 
              @click="del(scope.row)"><i class="iconfont icon-icon_operat_delete" style="height: 16px;width:16px"></i> {{$t("public.del")}}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <kl-pagination
      :total="total"
      :currentPage="currentPage"
      @current-change="currentchange"
      @size-change="sizeChange"
      :pageSize="pageSize"
    ></kl-pagination>
    <!-- 年检弹窗 -->
    <el-dialog class="dialog" :title="title" :visible.sync="dialogVisible" width="440px" :close-on-click-modal="false">
      <div  style="text-align:left;">
        <el-form ref="form" :model="form" :rules="rules1" :label-position="LanguageId == 1 ? 'right' : 'top'">
          <el-form-item :label="$t('maintenance.carNo') + '：'" label-position="right" label-width="110px" filterable  prop="selCarNo">
            <el-select v-model="form.selCarNo" placeholder="" :size="size" :style="{'width':LanguageId == 1 ? '250px' : '100%'}" :disabled="isEdit" filterable clearable>
              <el-option v-for="item in vehiclesOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('maintenance.entryTime') + '：'" label-position="right" label-width="110px" prop="entryTime">
            <el-date-picker v-model="form.entryTime" placeholder="" :size="size" :style="{'width':LanguageId == 1 ? '250px' : '100%'}" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('maintenance.OPTName') + '：'" label-position="right" label-width="110px" filterable >
            <el-input v-model="form.entryMan" :style="{'width':LanguageId == 1 ? '250px' : '100%'}"  :size="size"></el-input>
          </el-form-item>
          <el-form-item :label="$t('maintenance.NJDaterange') + '：'" label-position="right" label-width="110px" prop="daterange">
            <el-date-picker :size="size" :style="{'width':LanguageId == 1 ? '250px' : '100%'}"
              v-model="form.daterange"
              type="daterange"
              :range-separator="$t('time.to')"
              :start-placeholder="$t('time.startDate')"
              :end-placeholder="$t('time.endDate')"
              :clearable="false">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t("public.cancel")}}</el-button>
        <el-button type="primary" @click="submitSave">{{$t("public.save")}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import KLLabel from '@/components/KLLabel.vue'
import Enrollment from '../components/enrollment.vue'
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
import settings from '@/settings';
export default {
    name: "annualInspection",
  data(){
    var validateDate = (rule, value, callback) => {
      // console.log(value);
      if (value === "") {
        callback(new Error(this.$t('maintenance.Select_time_range')));
      }else if(value == null || value == undefined){
        callback(new Error(this.$t('maintenance.Select_time_range')));
      } else if(value.length == 0){
         callback(new Error(this.$t('maintenance.Select_time_range')));
      }else{
        callback();
      }
    };
    return{
      rules1:{
        selCarNo: [
          { required: true, message: this.$t('maintenancemanagement.selectvehicle'), trigger: 'change' }
        ],
        entryTime: [
          { required: true, message: this.$t('vehicleInfo.selectusedate'), trigger: 'change' }
        ],
        daterange: [
          {  required: true, validator: validateDate, trigger: "change" },
        ]
      },
      currentPage:1,
      total:0,
      loading:false,
      isEdit:false,
      form:{
        entryTime:"",
        selCarNo:"",
        entryMan:"",
        daterange:[],
      },
      dialogVisible:false,
      dataList:[],
      inputCarNo:"",
      vehicles:[],
      vehiclesOption:[],
      NextCheckTimeTemp:undefined,
      VehicleID:undefined,
      LanguageId:1,
      CheckID:0,
      pageSize:10,
    }
  },
  props:{},
  components:{ Enrollment, KLLabel},
  computed:{
    size() {
      return this.$store.getters.size
    },
    title(){
      if(this.isEdit) return this.$t("maintenance.NJEdit");
      else return this.$t("maintenance.NJ");
    },
    ...mapState({
      operator: (state) => state.user.operator,
      appVehicles: state => state.app.vehicles,
    }),
  },
  watch:{
  },
  methods:{
    currentchange(page){
      this.currentPage = page;
      this.getList();
    },
    sizeChange(val){
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    getappVehicles(){
      //var appVeh = [];
      setTimeout(() => {
        for(var item = 0; item < this.appVehicles.data.length; item++){
          if(this.appVehicles.data[item].treeLevel == 5){
            this.vehiclesOption.push(
              {
                value: this.appVehicles.data[item].nodeValue,
                label: this.appVehicles.data[item].vehicleName,
              }
            )
          }
        }
        //console.log(this.vehiclesOption);
      }, 50)
    },
    getList(){
      this.loading = true;
      this.$api.annualInspectionInfo({
        vehicle: this.inputCarNo,
        // CompanyID: 5657,
        CompanyID: this.operator.CompanyId,
        PageNo: this.currentPage,
        PageSize: this.pageSize,
        OperatorID: this.$store.getters.operator.OperatorId,
      })
      .then((res)=>{
        if(res.code == 200){
          this.total = res.count;
          this.dataList = res.data;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
        this.total = 0;
        this.dataList = [];
      })
    },
    submitSave(){
      let VID = '';
      var flag = 0;
      flag = this.isEdit == true ? 1 : 0;
      VID = flag == 0 ? this.form.selCarNo : this.VehicleID;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // console.log(this.form.daterange);
          if((this.form.daterange == null || this.form.daterange == undefined || this.form.daterange.length == 0)){
            // this.$message.info("请填写年检期限");
            return;
          }
          this.$api.annualInspectionSave({
            VehicleID: VID,
            entryTime: this.moment(this.form.entryTime).format("YYYY-MM-DD"),
            OperatorID: this.operator.OperatorId,
            beginCheckTime: this.moment(this.form.daterange[0]).format("YYYY-MM-DD"),
            nextCheckTime:this.moment(this.form.daterange[1]).format("YYYY-MM-DD"),
            NJFlag: flag,
            NextCheckTimeTemp: flag == 0 ? "" : this.NextCheckTimeTemp,
			CheckID:this.CheckID
          })
          .then((res)=>{
            if(res.code == 200){
              this.getList();
              this.dialogVisible = false;
              this.$message.success(this.$t("public.hasSaved"));
            }
          })
          .catch((e)=>{
            this.dialogVisible = false;
            let errorInfo = "";
            if(e.response.data.message === "查询到之前设置过年检记录") errorInfo = "，"+ this.$t("maintenance.RecordsAlreadyExist");
            this.$message.error(this.$t("public.SaveFail") + errorInfo);
          })
        } else {
        }
      });
      
    },
    handleQuery(val){
      this.inputCarNo = val;
      this.currentPage = 1;
      this.getList();
    },
    add(){
      this.isEdit = false;
      this.dialogVisible = true;
	  this.CheckID=0;
      this.resetForm("form");
    },
    edit(row){
      
      this.isEdit = true;
      this.dialogVisible = true;
      this.NextCheckTimeTemp = row.nextCheckTime;
      this.VehicleID = row.VID;
	  this.CheckID=row.CheckID;
      var addlistform = JSON.parse(JSON.stringify(row))
      // 给对象赋值，需要用$set即可
      this.$set(addlistform,'entryTime',row.entryTime)
      this.$set(addlistform,'daterange',[row.beginCheckTime,row.nextCheckTime])

      this.form = {
        entryTime : row.entryTime,
        selCarNo : row.carNo,
        entryMan : row.OPTName,
        daterange : [row.beginCheckTime,row.nextCheckTime],
      }
    },
    del(row){
      //需要加个vin，待改
      console.log(row)
      this.$confirm(
        this.$t("maintenance.confirmDelete") + " " + row.carNo,
        "",
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      )
      .then(() => {
        //console.log(selectVID[0].value);
        this.$api.annualInspectionDel({
          VehicleID: row.VID,
          nextCheckTime: row.nextCheckTime,
		  CheckID:row.CheckID
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.getList();
            this.$message.success(this.$t("public.hasDeleted"));
          } 
        })
        .catch((e)=>{
          this.$message.error(this.$t("public.DeleteFail"));
        })
      })
      .catch(() => {});
    },
    resetForm(refName) {
      this.form = {
        entryTime : new Date(),
        selCarNo : "",
        entryMan : this.operator.OpeName,
        daterange : [],
      }
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    }
  },
  mounted(){
       const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.getList();
    // setTimeout(() => {
    //   this.vehicles = this.getappVehicles();
    // }, 300)
    this.form.entryMan = this.operator.OpeName;
    this.getappVehicles();
    this.LanguageId = language(this.$store.getters.locale)

  },
}
</script>
<style lang="scss" scoped>
.dialog{
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #EBEEF5 !important;
  }

}
 
.page_container_a {
  margin-top: 10px;

  ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

  ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 
</style>